import axios from './axios';

// const baseApiUrl = process.env.REACT_APP_API_URL;
const endPoint = '/music-studio';
const endPoint2 = '/music-studio-assets';
const baseApiUrl = process.env.REACT_APP_API_URL;


const create = (body) => {
    return axios.post(`${endPoint}`, {
        ...body
    });
}
const getSubAssetList = () => {
    return axios.get(`${endPoint2}/list`);
}

const downloadMusicStudioBrochure = () => {
    return `${baseApiUrl}/music-studio-brochure`;
}

export default {
    create,
    getSubAssetList,
    downloadMusicStudioBrochure
};